import cn from 'classnames'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'
import LabelWrapper from '../LabelWrapper'

const TextArea = props => {
  const {
    actionLink,
    className,
    cols,
    customCol,
    customMargin,
    customPadding,
    customWidth,
    disabled,
    disableIconClick,
    errorText,
    fullWidth,
    helperText,
    id,
    isLabelInline,
    isRequired,
    isToolTip,
    justify,
    label,
    labelIcon,
    multipleFields,
    noMobile,
    notWrapper,
    noWrap,
    onClick,
    rows,
    showActionLink,
    spacing,
    textareaRef,
    toolTipIcon,
    toolTipIconColor,
    toolTipIconSize,
    toolTipPosition,
    toolTipText,
    withBorder,
    withDivider,
    ...rest
  } = props

  return (
    <ThemeProvider theme={theme}>
      <LabelWrapper
        actionLink={actionLink}
        className={cn('input-textarea', className)}
        customCol={customCol}
        customMargin={customMargin}
        customPadding={customPadding}
        customWidth={customWidth}
        disabled={disabled}
        disableIconClick={disableIconClick}
        errorText={errorText}
        fullWidth={fullWidth}
        helperText={helperText}
        id={id}
        isLabelInline={isLabelInline}
        isRequired={isRequired}
        isToolTip={isToolTip}
        justify={justify}
        label={label}
        labelIcon={labelIcon}
        multipleFields={multipleFields}
        noMobile={noMobile}
        notWrapper={notWrapper}
        noWrap={noWrap}
        onClick={onClick}
        showActionLink={showActionLink}
        spacing={spacing}
        toolTipIcon={toolTipIcon}
        toolTipIconColor={toolTipIconColor}
        toolTipIconSize={toolTipIconSize}
        toolTipPosition={toolTipPosition}
        toolTipText={toolTipText}
        withBorder={withBorder}
        withDivider={withDivider}
      >
        <TextAreaField
          className={cn('com-textarea', className)}
          disabled={disabled}
          cols={cols}
          id={id}
          rows={rows}
          ref={textareaRef}
          resize="both"
          style={customWidth ? { width: `${customWidth}px` } : {}}
          {...rest}
        />
      </LabelWrapper>
    </ThemeProvider>
  )
}

TextArea.defaultProps = {
  children: '',
  className: null,
  cols: 50,
  customWidth: null,
  errorText: '',
  id: '',
  isLabelInline: false,
  isRequired: false,
  label: '',
  notWrapper: true,
  rows: 3,
  withBorder: true,
}

const TextAreaField = styled.textarea`
  width: 100%;
  padding: 8px;
  box-sizing: border-box;
  display: flex;
  border: 1px solid ${`var(--gameday-inputField-inputBorder, ${theme.inputField.inputBorder})`};
  border-radius: 4px;
  color: ${`var(--gameday-inputField-inputTextColor, ${theme.inputField.inputTextColor})`};
  font-size: ${props => props.theme.typography.fontSizeSm};
  outline: none;
  resize: both;
  font-family: ${props => props.theme.typography.defaultFont};
  background-color: var(--gameday-inputField-inputBGColor, ${theme.inputField.inputBGColor});
  &:focus {
    border-color: ${props => props.theme.inputField.inputBorderActive};
    font-weight: ${props => props.theme.typography.fontWeightBolder};
  }
  &:disabled {
    background-color: ${`var(--gameday-inputField-inputBGDisabled, ${theme.inputField.inputBGDisabled})`};
    border-color: ${`var(--gameday-inputField-inputBorderDisabled, ${theme.inputField.inputBorderDisabled})`};
    color: ${`var(--gameday-inputField-inputTextColorDisabled, ${theme.inputField.inputTextColorDisabled})`};
    opacity: ${props => props.theme.inputField.inputDisabledOpacity};
    &:hover {
      cursor: not-allowed;
    }
  }
  &::placeholder {
    color: var(--gameday-body-textColorAlt, ${theme.body.textColorAlt});
    opacity: 0.7;
    font-weight: ${props => props.theme.typography.fontWeightNormal};
  }
`

export default TextArea
